import { ROUTER_PATHS } from "@/shared";
import { useFetchGetDashboard } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";
import { useTheme } from "@emotion/react";
import { CastSharp } from "@mui/icons-material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BuildIcon from "@mui/icons-material/Build";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { OverviewChartPreventas } from "../OverviewChartPreventas";
import { StatBox } from "../StatBox";

export type DashboardViewProps = {};

type dataDashboard = {
  total_cliente: string;
  total_prospecto: string;
  total_preventa: string;
  total_preagedamiento: string;
  total_ordentrabajo: string;
};
const DashboardView: React.FC<DashboardViewProps> = () => {
  const theme = useTheme() as any;

  const [dataDashboard, setDataDashboard] = useState<dataDashboard | null>(
    null
  );
  const { isPending: isPendingDashboard, mutateAsync: mutateAsyncDashboard } =
    useFetchGetDashboard();

  useEffect(() => {
    getDataDashboard();
  }, []);

  async function getDataDashboard() {
    const resp = await mutateAsyncDashboard();
    const totalCliente = resp.data.clientes_por_mes_anio.reduce(
      (acc, obj) => acc + obj.total,
      0
    );
    const totalOrdenTrabajo = resp.data.ordenes_trabajo_por_mes_anio.reduce(
      (acc, obj) => acc + obj.total,
      0
    );
    const totalPreagendamiento = resp.data.preagendamientos_por_mes_anio.reduce(
      (acc, obj) => acc + obj.total,
      0
    );
    const totalPreventa = resp.data.preventas_por_mes_anio.reduce(
      (acc, obj) => acc + obj.total,
      0
    );
    const totalProspecto = resp.data.prospecto_por_mes_anio.reduce(
      (acc, obj) => acc + obj.total,
      0
    );

    setDataDashboard({
      
      total_cliente: totalCliente.toString(),
      total_prospecto: totalProspecto.toString(),
      total_preventa: totalPreventa.toString(),
      total_preagedamiento: totalPreagendamiento.toString(),
      total_ordentrabajo: totalOrdenTrabajo.toString(),
    });
  }

  if (isPendingDashboard) return <LoaderComponent />;

  return (
    <Grid container spacing={1} padding={1}>
      <Grid lg={3} sm={6} xs={12}>
        <StatBox
          title="Total Prospectos"
          value={dataDashboard?.total_prospecto ?? "0"}
          increase="+10%"
          description="Desde el mes pasado"
          theme={theme}
          icon={<GroupAddIcon />}
          backgroundColor="#635bff"
          urlNavigate={ROUTER_PATHS.ventas.prospectoNav}
        />
      </Grid>

      <Grid lg={3} sm={6} xs={12}>
        <StatBox
          title="Total Preventas"
          value={dataDashboard?.total_preventa ?? "0"}
          increase="+6%"
          description="Desde el mes pasado"
          theme={theme}
          icon={<CastSharp />}
          backgroundColor="#15b79f"
          urlNavigate={ROUTER_PATHS.ventas.preventasNav}
        />
      </Grid>
      
      <Grid lg={3} sm={6} xs={12}>
        <StatBox
          title="Total Preagendamiento"
          value={dataDashboard?.total_preagedamiento ?? "0"}
          increase="+1%"
          description="Desde el mes pasado"
          theme={theme}
          backgroundColor="#fb9c0c"
          icon={<AssignmentIcon />}
          urlNavigate={ROUTER_PATHS.ventas.preAgendamientoNav}
        />
      </Grid>

      <Grid lg={3} sm={6} xs={12}>
        <StatBox
          title="Total Instalación"
          value={dataDashboard?.total_ordentrabajo ?? "0"}
          increase="-10%"
          description="Desde el mes pasado"
          theme={theme}
          backgroundColor="#635bff"
          icon={<BuildIcon />}
          urlNavigate={ROUTER_PATHS.ventas.instalacionAsignadoNav}
        />
      </Grid>

      <Grid xs={12}>
        <OverviewChartPreventas
          chartSeries={[
            {
              name: "This year",
              data: [18, 16, 5, 8, 3, 14, 14, 16, 17, 19, 18, 20],
            },
            {
              name: "Last year",
              data: [12, 11, 4, 6, 2, 9, 9, 10, 11, 12, 13, 13],
            },
          ]}
          sx={{ height: "100%" }}
        />
      </Grid>
    </Grid>
  );
};

export default DashboardView;
